import { Component, OnInit, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TemporadaService } from '../../../catalogos/temporadas/services/temporada.service';
import { TemporadaViewModel } from '../../../catalogos/temporadas/models/temporada-view-model';

import { EquipoService } from '../../../catalogos/equipos/services/equipo.service';
import { EquipoViewModel } from '../../../catalogos/equipos/models/equipo-view-model';

import { CompeticionService } from '../../../catalogos/competiciones/services/competicion.service';
import { CompeticionViewModel } from '../../../catalogos/competiciones/models/competicion-view-model';

import { PartidoService } from '../../../competiciones/partidos/services/partido.service';
import { PartidoViewModel } from '../../../competiciones/partidos/models/partido-view-model';

@Component({
    selector: 'app-agenda-list',
    templateUrl: './agenda-list.component.html',
    styleUrls: ['./agenda-list.component.scss']
})
export class AgendaListComponent implements OnInit {

    constructor(
        private temporadaService: TemporadaService,
        private equipoService: EquipoService,
        private competicionService: CompeticionService,
        private partidoService: PartidoService,
        private modalService: NgbModal,
        private renderer: Renderer2) { }

    ngOnInit(): void {
        this.loadTemporadas();
        let competicionesFavoritas = localStorage.getItem('competicionesFavoritas');
        if (competicionesFavoritas != null)  {
            this.localCompeticionesFavoritas = JSON.parse(competicionesFavoritas);
            
            if (this.localCompeticionesFavoritas.length == 0){
                this.onlyFavorites = false; 
                this.setImgFavoriteSource ();
            }
            
        } else {
            this.onlyFavorites = false; 
            this.setImgFavoriteSource ();
        }
    }

    loading: boolean = false;

    temporadas: TemporadaViewModel[] = [];
    temporadaSel: TemporadaViewModel | null =  null;

    loadTemporadas() {
        this.loading = true;
        this.temporadaService.getTemporadas().subscribe(response => {
            this.temporadas = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const temporada: TemporadaViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    fechaInicio: data.fechaInicio,
                    fechaFin: data.fechaFin,
                    finalizada: data.finalizada,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja
                };

                this.temporadas.push(temporada);
            });
            
            if (this.temporadas.length > 0) {
                this.temporadaSel = this.temporadas[0];
                this.loadEquipos(this.temporadaSel.id);
            }

            this.loading = false;
        });
    }

    equipos: EquipoViewModel[] = [];

    loadEquipos(temporadaId: string) {
        this.loading = true;
        this.equipoService.getEquipos(temporadaId).subscribe(response => {
            this.equipos = [];
            this.partidos = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const equipo: EquipoViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    categoriaId: data.categoriaId,
                    codFmp: data.codFmp,
                    orden: data.orden,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId
                };

                this.equipos.push(equipo);
                this.loadCompeticiones(temporadaId, equipo.id);
            });

            this.loading = false;
        });
    }

    competiciones: CompeticionViewModel[] = [];
    competicionSel: CompeticionViewModel | null = null;

    loadCompeticiones(temporadaId: string, equipoId: string) {
        this.loading = true;
        this.competicionService.getCompeticiones(temporadaId, equipoId).subscribe(response => {
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const competicion: CompeticionViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    orden: data.orden,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId,
                    equipoId: equipoId
                };

                this.competiciones.push(competicion);
                this.loadPartidos(competicion.temporadaId, competicion.equipoId, competicion.id, competicion.descripcion);
            });

            this.loading = false;
        });
    }

    partidos: PartidoViewModel[] = [];

    loadPartidos(temporadaId: string, equipoId: string, competicionId: string, competicionName: string) {
        this.partidoService.getPartidos(temporadaId, equipoId, competicionId).subscribe(response => {
            let todayDate = new Date();
            todayDate.setHours(0,0,0,0);
            
            let sevenMoreDate = new Date();
            sevenMoreDate.setDate(todayDate.getDate() + 7);

            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const partido: PartidoViewModel = {
                    id: id,
                    idPartido: data.idPartido,
                    descPartido: data.descPartido,
                    equipoLocal: data.equipoLocal,
                    equipoVisitante: data.equipoVisitante,
                    fecha: data.fecha,
                    hora: data.hora,
                    resultado: data.resultado,
                    pista: data.pista,
                    temporadaId: temporadaId,
                    equipoId: equipoId,
                    competicionId: competicionId,
                    competicionName: competicionName
                };
                
                let partidoDate = new Date(partido.fecha);
                
                let mostrar : boolean = true;
                
                if (this.onlyFavorites){
                    let index = -1;
                    if (this.localCompeticionesFavoritas.length > 0){
                        index = this.localCompeticionesFavoritas.findIndex(value => value.id == partido.competicionId);

                        if (index > -1){
                            mostrar = true;
                        } else {
                            mostrar = false;
                        }
                    } else {
                        mostrar = false;
                    }
                    
                }
                
                if(partidoDate >= todayDate && partidoDate <= sevenMoreDate && mostrar) {
                    this.partidos.push(partido);
                    this.sortByDueDate();
                }
            });
        });
    }
    
    localCompeticionesFavoritas : CompeticionViewModel[] = [];
    
    onlyFavorites: boolean = true;

    selectFavoriteCompeticion() {
        this.onlyFavorites = !this.onlyFavorites;
        this.setImgFavoriteSource();
        this.loadTemporadas();
    }
    
    setImgFavoriteSource (){
        const imgFavorite = document.getElementById('imgFavorite') as HTMLImageElement;
        if (this.onlyFavorites) {
            imgFavorite.src = "/assets/imgs/ic_estrella_selected.png";
        } else  {
            imgFavorite.src = "/assets/imgs/ic_estrella_unselected.png";
        }
    }
    
    sortByDueDate() {
        this.partidos.sort((a: PartidoViewModel, b: PartidoViewModel) => {
			let fechaA = new Date(a.fecha);
			if(a.hora != null && a.hora != ""){
				fechaA.setHours(parseInt(a.hora.split(":")[0],10));
				fechaA.setMinutes(parseInt(a.hora.split(":")[1],10));
			}
			let fechaB = new Date(b.fecha);
			if(b.hora != null && b.hora != ""){
				fechaB.setHours(parseInt(b.hora.split(":")[0],10));
				fechaB.setMinutes(parseInt(b.hora.split(":")[1],10));
			}
            return this.getTime(fechaA) - this.getTime(fechaB);
        });
    }
    
    getTime(date?: Date) {
        return date != null ? date.getTime() : 0;
    }
    
    openMaps (destino: string){
        window.open('http://maps.google.com/?q=' + destino, '_self');
    } 
}
